export const prepareEmbedUrl = (url, embedVia) => {
  switch (embedVia) {
    case 'google-docs':
      return `https://docs.google.com/viewer?embedded=true&url=${encodeURIComponent(url)}`;
    default:
      return url;
  }
}